import React, {lazy} from 'react';
import './App.scss';
import './locales/language';
import { BrowserRouter, Routes, Route} from "react-router-dom";

const StationDetails = lazy(() => import("./pages/stationDetails"));
const Invoice = lazy(() => import("./pages/invoice"));
const ErrorMessagePage = lazy(() => import("./components/errorMessagePage"));

function App() {
  return (
    <div className="App">
        <BrowserRouter>
            <Routes>
                <Route path='/chg/:id' element={<StationDetails/>}/>
                <Route path='chg/:id/invoice/:last4' element={<Invoice/>} />
                <Route path='/error/:id' element={<ErrorMessagePage/>} />
            </Routes>
        </BrowserRouter>
    </div>
  );
}

export default App;
